var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.getRichTextParts(_vm.value)),function(block,i){return [(block.type === 'url')?_c('a',{key:i,attrs:{"href":block.value,"target":"_blank"}},[_vm._v(" "+_vm._s(block.value)+" ")]):_c('span',{key:i},[_vm._v(_vm._s(block.value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }